export const MapConstants = {
  DEFAULT_ASSET_LATITUDE: 48.880343,
  DEFAULT_ASSET_LONGITUDE: 2.325582
};


// WEBPACK FOOTER //
// ./src/constants/MapConstants.js